<template>
    <div class="allergens-container" role="list" :aria-label="`Allergens: ${getAllergensLabel()}`">
        <fragment v-if="allergens != null"> 
            <announcing-tooltip
                v-for="allergen in allergens" 
                :key="allergen.AllergenId"
                :text="getAllergenName(allergen)"
                prefix="Allergen"
            >
                <img 
                    :src="variant == 'extra-large' ? allergen.DescriptiveIconUrl : allergen.IconUrl" 
                    :alt="getAllergenName(allergen)"
                    :class="iconClass"
                    role="presentation" />
            </announcing-tooltip>
        </fragment>
        <fragment v-if="customAllergens != null">
            <announcer
                v-for="customAllergen in customAllergens"
                :key="`custom-${customAllergen}`"
                :text="customAllergen"
                prefix="Allergen"
                :aria-label="customAllergen"
            >
                <span :class="['custom-allergen', customAllergenClass]">
                    {{ customAllergen }}
                </span>
            </announcer>
        </fragment>
        <not-set-icon
            v-if="allergens == null && item.CustomAllergens == null"
            tooltip-text="Not set by District"
            prefix="Allergens"
            :size="notSetIconSize"
        />
    </div>
</template>

<script>
import { Fragment } from 'vue-frag';
import menuItemMixin from '../js/mixins/menuItemMixin';
import announcer from './announcer.vue';
import announcingTooltip from './announcingTooltip.vue';
import notSetIcon from './notSetIcon.vue';

export default {
    name: 'allergens',
    components: {
        'announcing-tooltip': announcingTooltip,
        'announcer': announcer,
        'fragment': Fragment,
        'not-set-icon': notSetIcon
    },
    mixins: [menuItemMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        variant: {
            type: String,
            default: 'large',
            validator: value => ['extra-large', 'large', 'small'].includes(value)
        },
    },
    computed: {
        customAllergens() {
            return this.getCustomAllergens(this.item);
        },
        allergens() {
            return this.getAllergens(this.item);
        },
        iconClass() {
            return `allergen-${this.variant}`
        },
        notSetIconSize() {
            if (this.variant === 'extra-large') return 'large';
            return 'medium';
        },
        customAllergenClass() {
            return `custom-allergen-${this.variant}`;
        }
    },
    methods: {
        getAllergenName(allergen) {
            return allergen.AllergenName;
        },
        getAllergensLabel() {
            return this.getAllAllergensForLabel(this.item);
        }
    }
}
</script>

<style scoped>
.allergens-container {
    display: flex;
    gap: 4px;
    /* width: fit-content !important; */
    flex-wrap: wrap;
}

.allergen-extra-large {
    width: 48px;
    height: 48px;
}

.allergen-large {
    width: 32px;
    height: 32px;
}

.allergen-small {
    width: 24px;
    height: 24px;
}

.custom-allergen {
    background-color: #F3B6D3;
    border-radius: 8px;
    font-weight: 500;
    color: #333;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.custom-allergen-extra-large {
    font-size: 14px;
    height: 48px;
    padding: 0 14px;
}

.custom-allergen-large {
    font-size: 12px;
    height: 32px;
    padding: 0 12px;
}

.custom-allergen-small {
    font-size: 10px;
    height: 24px;
    padding: 0 10px;
}

</style>